import {createSvgIcon} from '../create-svg-icon';

export const ExpandLessIcon = createSvgIcon(
  <path d="m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14l-6-6z" />
, 'ExpandLessOutlined');
